import { Comment, NewsFeedEntry, FeatureRequest, TrelloCard } from './../../../sharedTypes/client';
import { Termin } from './../../../sharedTypes/termin';
import { Knowledge, Topic, Video } from './../../../sharedTypes/knowledgebase';
import { Notiz } from './../../../sharedTypes/notiz';
import { Call } from './../../../sharedTypes/call';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Client, Lead, LoggedUpdate, Ticket } from 'sharedTypes/client';
import { environment } from './../../environments/environment';
import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Admin, AdminAction, AdminStatus, SharedSettings } from 'sharedTypes/admin';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { CallDialogComponent } from '../core/dialogs/call-dialog/call-dialog.component';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FirestoreInstances, limit, orderBy, where } from '@angular/fire/firestore';
import { AccountCheckList, AccountToDo } from 'sharedTypes/accountChecklist';
import { FirestoreService } from './firestore.service';
import { FirebaseApps } from '@angular/fire/app';
import { getAuth, onIdTokenChanged, signInWithCustomToken } from '@angular/fire/auth';
import { connectFunctionsEmulator, Functions, FunctionsInstances, httpsCallable } from '@angular/fire/functions';
import { onAuthStateChanged } from 'firebase/auth';
import { Offer } from 'sharedTypes/offer';
import { Order } from 'sharedTypes/order';

@Injectable()
export class FirebaseService {
    callSub: Subscription = new Subscription();
    myCalls: Call[] = [];
    missedCalls: Call[] = [];
    admin = new BehaviorSubject<Admin>(new Admin());
    firebaseApps: FirebaseApps;

    constructor(
        private authService: AuthService,
        private dialog: MatDialog,
        public snackBar: MatSnackBar,
        public allFirestoreDbs: FirestoreInstances,
        public allFunctions: FunctionsInstances,
        private firestoreService: FirestoreService,
    ) {
        this.firebaseApps = inject(FirebaseApps);

        onAuthStateChanged(getAuth(this.firebaseApps[0]), async (auth: any) => {
            if (auth) {
                console.log('FirebaseService auth', auth);
                this.admin.next((await auth.getIdTokenResult()).claims as Admin);
            } else {
                console.log('FirebaseService no auth');
                this.admin.next(new Admin());
            }
            console.log('FirebaseService onAuthStateChanged', auth);
            console.log('FirebaseService onAuthStateChanged admin', this.admin.getValue());
        });

        getAuth().onAuthStateChanged((auth: any) => {
            if (auth) {
                console.log('start');
                this.startSubs();
            } else {
                //
                this.endSubCalls();
                this.admin.next(new Admin());
            }
        });
    }

    async checkLogsLogin() {
        const auth = getAuth(this.firebaseApps[1]);
        if (!auth.currentUser) {
            const token = await this.requestLogsLoginToken();
            await signInWithCustomToken(auth, token);
        }
    }

    async fns(functionName: string, data: any = {}) {
        this.checkLocalFnc();
        const result = await httpsCallable(this.allFunctions[0], functionName)(data);
        console.log('Function called:', functionName, 'with data:', data);
        return result.data as any;
    }
    requestLogsLoginToken() {
        this.checkLocalFnc();
        return this.fns('requestPdrcloudLogsLoginToken', {});
    }

    requestClientChecklist(clientId: string) {
        this.checkLocalFnc();
        return this.fns('requestClientChecklist', { clientId });
    }
    async requestSaveClientToDo(clientId: string, toDo: AccountToDo) {
        await this.saveAdminAction('requestSaveClientToDo', clientId);
        this.checkLocalFnc();
        return this.fns('requestSaveClientToDo', { clientId, toDo });
    }
    async requestAddClientToDos(clientId: string, listId: string) {
        await this.saveAdminAction('requestAddClientToDos', clientId);
        this.checkLocalFnc();
        return this.fns('requestAddClientToDos', { clientId, listId });
    }
    async requestDeleteClientToDo(clientId: string, toDoId: string) {
        await this.saveAdminAction('deleteClientToDo', clientId);
        this.checkLocalFnc();
        return this.fns('requestDeleteClientToDo', { clientId, toDoId });
    }
    async getAccountCfg(clientId: string) {
        await this.saveAdminAction('getAccountCfg', clientId);
        this.checkLocalFnc();
        return this.fns('getAccountCfg', { clientId });
    }
    async setVerifiedDomains(clientId: string, verifiedDomains: string[]) {
        await this.saveAdminAction('setVerifiedDomains', clientId);
        this.checkLocalFnc();
        return this.fns('setVerifiedDomains', { clientId, verifiedDomains });
    }

    async activateAudatex(clientId: string) {
        await this.saveAdminAction('activateAudatex', clientId);
        this.checkLocalFnc();
        return this.fns('activateAudatex', { clientId });
    }
    async setDebitor(clientId: string, newDebitor: number) {
        await this.saveAdminAction('setDebitor', clientId + ' set to: ' + newDebitor.toString());
        this.checkLocalFnc();
        return this.fns('setDebitor', { clientId, newDebitor });
    }
    async setLockMessage(clientId: string, lockMessage: string) {
        await this.saveAdminAction('setLockMessage', clientId + ' set to: ' + lockMessage);
        this.checkLocalFnc();
        return this.fns('setLockMessage', { clientId, lockMessage });
    }
    async resetUserMfa(userId: string) {
        await this.saveAdminAction('resetUserMfa: ' + userId);
        this.checkLocalFnc();
        return this.fns('resetUserMfa', { userId });
    }
    async deleteInvoiceData(clientId: string) {
        await this.saveAdminAction('deleteInvoiceData', clientId);
        this.checkLocalFnc();
        return this.fns('deleteInvoiceData', { clientId });
    }
    async resetOrderFzDa(clientId: string, orderId: string) {
        await this.saveAdminAction('resetOrderFzDa', clientId + ' orderId: ' + orderId);
        this.checkLocalFnc();
        return this.fns('resetOrderFzDa', { clientId, orderId });
    }
    async setAccountSettings(clientId: string, settingsToSave: Partial<any>) {
        await this.saveAdminAction('setAccountSettings', clientId + ' settings: ' + JSON.stringify(settingsToSave));
        this.checkLocalFnc();
        return this.fns('setAccountSettings', { clientId, settingsToSave });
    }
    async setManualPayment(clientId: string) {
        await this.saveAdminAction('setManualPayment', clientId);
        this.checkLocalFnc();
        return this.fns('setManualPayment', { clientId });
    }

    async activateAudatexUntil(clientId: string, audatexUntilDate: number) {
        this.checkLocalFnc();
        return this.fns('activateAudatexUntil', { clientId, audatexUntilDate });
    }
    async setTestLizenz(clientId: string, testLizenz: number) {
        this.checkLocalFnc();
        return this.fns('setTestLizenz', { clientId, testLizenz });
    }

    createId() {
        return this.firestoreService.createId();
    }

    endSubCalls() {
        this.callSub.unsubscribe();
    }

    createPushId() {
        return this.firestoreService.createId();
    }

    async startSubs() {
        const claims = await this.authService.getUserClaims();
        if (!claims) {
            return;
        }
        // console.log(claims)
        if (!claims?.allowCalls || !claims.sipgateUserId) {
            console.log('Keine Calls');
            return;
        }

        this.callSub = this.getOpenCalls(claims.sipgatePhoneId).subscribe((calls) => {
            // console.log(calls);
            this.myCalls = calls.filter(
                (c) =>
                    (c.outgoing || (!c.outgoing && c.isAnswered)) &&
                    c.sipgateUserIds.indexOf(claims.sipgatePhoneId) > -1,
            );
            this.missedCalls = calls.filter((c) => !c.outgoing && !c.isAnswered);
        });
    }

    openCallWindows(call: Call) {
        this.myCalls.push(call);
        this.dialog.open(CallDialogComponent, {
            hasBackdrop: false,
            data: {
                call,
            },
        });
    }

    async createNewTicket(werte: { clientId?: string; leadId?: string; callId?: string }) {
        await this.saveAdminAction('createNewTicket', '');
        const neuesTicket = new Ticket();

        if (werte.clientId) {
            neuesTicket.clientId = werte.clientId;
        }
        if (werte.callId) {
            neuesTicket.callId = werte.callId;
        }
        if (werte.leadId) {
            neuesTicket.type = 'lead';
            neuesTicket.leadId = werte.leadId;
        }
        neuesTicket.clientInfo = `Problembeschreibung:

    Auftragsnummer:
    Ansprechpartner:
    `;
        neuesTicket.ticketId = this.firestoreService.createId();
        neuesTicket.createdAt = new Date().toISOString();
        neuesTicket.createdAtUnix = Date.now();
        neuesTicket.createdBy = this.authService.getUid();
        neuesTicket.lastAnswerBySupportAtUnix = Date.now();
        neuesTicket.lastAnswerAtUnix = Date.now();
        neuesTicket.lastAnswerBy = 'support';
        const proms = [
            this.firestoreService.setFirestoreDocument(
                'tickets/' + neuesTicket.ticketId,
                JSON.parse(JSON.stringify(neuesTicket)),
            ),
        ];
        if (werte.callId) {
            proms.push(
                this.firestoreService.updateFirestoreDocument('calls/' + neuesTicket.callId, {
                    ticketId: neuesTicket.ticketId,
                }),
            );
        }
        await Promise.all(proms);
        return neuesTicket.ticketId;
    }

    async createNewFeatureRequest(werte: { clientId?: string }) {
        await this.saveAdminAction('createNewFeatureRequest', '');
        const newFeatureRequest = new FeatureRequest();

        if (werte.clientId) {
            newFeatureRequest.clientAccountId = werte.clientId;
        }
        newFeatureRequest.id = this.firestoreService.createId();
        newFeatureRequest.createdAt = new Date().toISOString();
        newFeatureRequest.createdAtUnix = Date.now();
        newFeatureRequest.createdBy = this.authService.getUid();
        const proms = [
            this.firestoreService.setFirestoreDocument(
                'featureRequests/' + newFeatureRequest.id,
                JSON.parse(JSON.stringify(newFeatureRequest)),
            ),
        ];
        await Promise.all(proms);
        return newFeatureRequest.id;
    }

    async saveAdminAction(action: string, addInfo = '') {
        console.log('FirebaseService saveAdminAction', action, addInfo);
        return this.authService.saveAdminAction(action, addInfo);
    }
    async saveAdminStatus(status: string) {
        return this.authService.saveAdminStatus(status);
    }

    async getAlgoliaKey() {
        this.checkLocalFnc();
        const res = await this.fns('getAlgoliaSearchkey', {});
        return res;
    }

    async requestLoginToken(uid: string, account: string) {
        await this.saveAdminAction('requestLogin', account);
        this.checkLocalFnc();
        const res = await this.fns('requestLoginToken', { uid, account });
        return res;
    }
    async requestSetUserFree(uid: string, account: string) {
        await this.saveAdminAction('requestSetUserFree', account);
        this.checkLocalFnc();
        const res = await this.fns('requestSetUserFree', { uid, account });
        return res;
    }
    async requestCreateTeanant(displayName: string, account: string) {
        await this.saveAdminAction('requestCreateTeanant', account);
        this.checkLocalFnc();
        const res = await this.fns('requestCreateTeanant', { displayName, account });
        return res;
    }

    filterTenant(zeichen: string) {
        zeichen = zeichen.split(' ').join('-');
        const NON_ALPHANUM = /[^a-zA-Z0-9\-]/g;
        return zeichen.replace(NON_ALPHANUM, '');
    }

    async requestMaAuswertung(von: string, bis: string, maId: string) {
        await this.saveAdminAction('requestTerminAuswertung', maId);
        this.checkLocalFnc();
        const res = await this.fns('requestTerminAuswertung', { maId, von, bis });
        return res;
    }
    async requestClientsSales(von: string, bis: string, maId: string) {
        await this.saveAdminAction('requestClientsSales', maId);
        this.checkLocalFnc();
        const res = await this.fns('requestClientsSales', { maId, von, bis });
        return res;
    }

    async requestCreateNewAccount(
        email: string,
        name: string,
        password: string,
        accountType: string,
        leadId: string,
        extraModule: any,
        testBis: number,
        copyAccountId: string,
    ) {
        await this.saveAdminAction('requestCreateNewAccount', email);
        this.checkLocalFnc();
        const res = await this.fns('requestCreateNewAccount', {
            email,
            name,
            password,
            accountType,
            leadId,
            extraModule,
            testBis,
            copyAccountId,
        });
        return res;
    }
    async requestCopyAccountData(fromAccountId: string, toAccountId: string) {
        await this.saveAdminAction('requestCopyAccountData', toAccountId);
        this.checkLocalFnc();
        const res = await this.fns('requestCopyAccountData', { fromAccountId, toAccountId });
        return res;
    }

    async adminToken() {
        this.checkLocalFnc();
        const res = await this.fns('adminToken', {});
        return res;
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async setUserClaims(admin: Admin) {
        this.checkLocalFnc();
        const res = await this.fns('requestSetUserRights', { admin });
        return res;
    }

    sendSnack(message: string) {
        const cfg = new MatSnackBarConfig();
        cfg.duration = 3000;
        this.snackBar.open(message, '', cfg);
    }

    async startCall(number: string) {
        await this.saveAdminAction('startCall', number);

        this.checkLocalFnc();
        this.sendSnack('Anruf gestartet!');
        const res = await this.fns('requestCall', { number });

        return res;
    }
    async requestCreateOrUpdateClient(accountId: string) {
        this.checkLocalFnc();
        const res = await this.fns('requestUpdateClient', { accountId });
        return res;
    }
    async requestImportAllAccounts() {
        this.checkLocalFnc();
        const res = await this.fns('requestImportAllAccounts', {});
        return res;
    }
    async requestImportAllUsers() {
        this.checkLocalFnc();
        const res = await this.fns('requestImportAllUsers', {});
        return res;
    }
    async requestSentTestNotification() {
        this.checkLocalFnc();
        const res = await this.fns('requestSentNotification', {});
        return res;
    }
    async localfnc() {
        this.checkLocalFnc();
        const res = await this.fns('localfnc', {});
        return res;
    }
    async allPhones() {
        this.checkLocalFnc();
        const res = await this.fns('allPhones', {});
        return res;
    }
    async sanitizeData() {
        this.checkLocalFnc();
        const res = await this.fns('santizeLeadData', {});
        return res;
    }
    async saveLeadToClient(leadId: string, clientId: string) {
        await this.saveAdminAction('saveLeadToClient', clientId);
        this.checkLocalFnc();
        const res = await this.fns('requestSaveLeadToClient', { leadId, clientId });
        return res;
    }
    async requestImportZoho() {
        this.checkLocalFnc();
        const res = await this.fns('requestImportZoho', {});
        return res;
    }

    checkLocalFnc() {
        if (!environment.production) {
            // Local testing
            console.log(this.allFunctions[0]);
            console.log('local functions!');
            connectFunctionsEmulator(this.allFunctions[0], 'localhost', 5000);
        }
    }
    getTicket(neuesTicketId: string) {
        return this.firestoreService.streamDocumentData<Ticket>('tickets/' + neuesTicketId);
    }
    getFeatureRequest(id: string) {
        return this.firestoreService.streamDocumentData<FeatureRequest>('featureRequests/' + id);
    }

    getClient(clientId: string) {
        return this.firestoreService.streamDocumentData<Client>('clients/' + clientId);
    }

    getComments(ticketId: string, folder = 'comments') {
        return this.firestoreService.streamCollectionData<Comment>(folder, [where('parentId', '==', ticketId)]);
    }
    getTicketCard(ticketId: string) {
        return this.firestoreService.streamCollectionData<TrelloCard>('trelloCards', [
            where('ticketId', '==', ticketId),
        ]);
    }

    getLines(text: any) {
        if (!text) {
            return '';
        }
        return text.split('\n').join('<br>');
    }

    async saveComment(comment: Comment, folder = 'comments') {
        await this.saveAdminAction('createdComment', comment.id);
        if (!comment.id) {
            comment.id = this.firestoreService.createId();
        }
        const jetzt = new Date().getTime();
        if (comment.edits.length === 0) {
            comment.edits.push({ text: comment.text, unix: jetzt });
        }
        comment.createdBy = this.authService.getUid();
        comment.createdByName = this.admin.getValue().name;
        comment.createdAt = new Date().toISOString();
        comment.createdAtUnix = Date.now();
        const comment2save = JSON.parse(JSON.stringify(comment));
        await this.firestoreService.setFirestoreDocument(folder + '/' + comment2save.id, comment2save);
        if (comment.parentType === 'ticket' && folder === 'comments') {
            await this.firestoreService.updateFirestoreDocument('tickets/' + comment.parentId, {
                updatedBySupportAtUnix: Date.now(),
                lastAnswerBySupportAtUnix: Date.now(),
                lastAnswerAtUnix: Date.now(),
                lastAnswerBy: 'support',
            });
        }
    }

    getClientsPromise(bookingActiv: boolean | null) {
        let queryConstraints = [where('booked', '==', true)];
        if (bookingActiv !== null) {
            queryConstraints.push(where('bookingActiv', '==', bookingActiv));
        }
        return this.firestoreService.fetchCollectionData<Client>('clients', queryConstraints);
    }

    getLeadsPromise(leadActiv: boolean | null) {
        let queryConstraints = [where('leadId', '!=', '')];
        if (leadActiv !== null) {
            queryConstraints.push(where('leadActiv', '==', leadActiv));
        }
        return this.firestoreService.fetchCollectionData<Client>('leads', queryConstraints);
    }

    getGeoErrorClients() {
        return this.firestoreService.streamCollectionData<Client>('clients/', [
            where('booked', '==', true),
            where('freieLizenz', '==', false),
            where('geoError', '==', true),
        ]);
    }
    getTypeErrorClients() {
        return this.firestoreService.streamCollectionData<Client>('clients/', [
            where('booked', '==', true),
            where('freieLizenz', '==', false),
            where('clientType', '==', ''),
        ]);
    }
    getClients() {
        return this.firestoreService.streamCollectionData<Client>('clients/');
    }
    knowledgeTopics() {
        return this.firestoreService.streamCollectionData<Topic>('knowledgeTopics/', [where('deleted', '==', false)]);
    }
    getVideos() {
        return this.firestoreService.streamCollectionData<Topic>('videos/', [where('deleted', '==', false)]);
    }
    getLead(leadId: string) {
        return this.firestoreService.streamDocumentData<Lead>('leads/' + leadId);
    }
    getKnowledge(knowledgeId: string, knowledgeBase: string) {
        let path = 'knowledge/';
        if (knowledgeBase === 'client') {
            path = 'clientKnowledge/';
        }
        return this.firestoreService.streamDocumentData<Knowledge>(path + knowledgeId);
    }
    getVideo(videoId: string) {
        return this.firestoreService.streamDocumentData<Knowledge>('videos/' + videoId);
    }
    getSharedSettings() {
        return this.firestoreService.streamDocumentData<SharedSettings>('settings/shared');
    }

    setSavedNotizTexts(savedNotizTexts: any) {
        return this.firestoreService.setFirestoreDocument('settings/shared', { savedNotizTexts }, true);
    }
    setTeamNews(teamNews: any) {
        return this.firestoreService.setFirestoreDocument('settings/shared', { teamNews }, true);
    }
    getOpenCalls(sipUser: string) {
        console.log(sipUser);
        return this.firestoreService.streamCollectionData<Call>('calls/', [
            where('archiv', '==', false),
            where('sipgateUserIds', 'array-contains', sipUser),
            orderBy('startAtUnix', 'desc'),
            limit(100),
        ]);
    }
    getAllCalls() {
        return this.firestoreService.streamCollectionData<Call>('calls/', [where('archiv', '==', false)]);
    }

    getClientLogins(clientId: string) {
        return this.firestoreService.streamCollectionData<any>('loginRequests/', [
            where('account', '==', clientId),
            orderBy('date', 'desc'),
            limit(20),
        ]);
    }
    getPdrUser(clientId: string) {
        return this.firestoreService.fetchCollectionData<AccountCheckList>('users', [
            where('account', '==', clientId),
            where('disabled', '==', false),
            where('f', '==', true),
        ]);
    }

    getClientUpdates(clientId: string) {
        return this.firestoreService.streamCollectionData<LoggedUpdate>('clientUpdates/', [
            where('dataId', '==', clientId),
            where('dataType', '==', 'client'),
            orderBy('updatedAtUnix', 'desc'),
            limit(20),
        ]);
    }

    getEventsByMonthIndex(index: string) {
        return this.firestoreService.streamCollectionData<any>('events/', [
            where('monthIndexes', 'array-contains', index),
            where('deleted', '==', false),
        ]);
    }

    deleteEvent(event: any) {
        // Updated: use FirestoreService for delete
        return this.firestoreService.deleteFirestoreDocument('events/' + event.Id);
    }

    async createTermin(termin: Termin) {
        await this.saveAdminAction('createdTermin', termin.Id);
        termin.monthIndexes = [];
        const indexStartTime = new Date(termin.StartTime).getMonth() + '-' + new Date(termin.StartTime).getFullYear();
        const indexEndTime = new Date(termin.EndTime).getMonth() + '-' + new Date(termin.EndTime).getFullYear();
        termin.monthIndexes.push(indexStartTime);
        if (indexEndTime !== indexStartTime) {
            termin.monthIndexes.push(indexEndTime);
        }

        termin.Id = this.firestoreService.createId();
        termin.createdBy = this.authService.getUid();
        termin.createdAt = new Date().toISOString();
        termin.createdAtUnix = Date.now();
        const termin2save = JSON.parse(JSON.stringify(termin));
        termin2save.maId = '';
        return this.firestoreService.setFirestoreDocument('events/' + termin.Id, termin2save);
    }

    async updateTermin(termin: Termin, savedTermin: Termin) {
        await this.saveAdminAction('updatedTermin', termin.Id);
        termin.updatedAt = new Date().toISOString();
        termin.updatedAtUnix = new Date().getTime();
        termin.monthIndexes = [];
        const indexStartTime = new Date(termin.StartTime).getMonth() + '-' + new Date(termin.StartTime).getFullYear();
        const indexEndTime = new Date(termin.EndTime).getMonth() + '-' + new Date(termin.EndTime).getFullYear();
        termin.monthIndexes.push(indexStartTime);
        if (indexEndTime !== indexStartTime) {
            termin.monthIndexes.push(indexEndTime);
        }

        const termin2save = JSON.parse(JSON.stringify(termin));
        termin2save.maId = '';
        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            termin.clientId,
            'termin',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedTermin,
            termin2save,
        );

        this.firestoreService.addToFirestoreCollection('terminUpdates/', JSON.parse(JSON.stringify(loggedUpdate)));
        return this.firestoreService.updateFirestoreDocument('events/' + termin2save.Id, termin2save);
    }

    getAdminActions(userId = '') {
        if (userId) {
            return this.firestoreService.streamCollectionData<AdminAction>('adminActions/', [
                where('uid', '==', userId),
                orderBy('atUnix', 'desc'),
                limit(10000),
            ]);
        } else {
            return this.firestoreService.streamCollectionData<AdminAction>('adminActions/', [
                orderBy('atUnix', 'desc'),
                limit(10000),
            ]);
        }
    }
    getLastAdminAction(uid: string) {
        return this.firestoreService.streamCollectionData<AdminAction>('adminActions/', [
            where('uid', '==', uid),
            orderBy('atUnix', 'desc'),
            limit(1),
        ]);
    }
    getLastAdminStatus(uid: string) {
        return this.firestoreService.streamCollectionData<AdminStatus>('adminStatus/', [
            where('uid', '==', uid),
            orderBy('atUnix', 'desc'),
            limit(1),
        ]);
    }

    getLastUserCall(sipgateUserId: string) {
        return this.firestoreService.streamCollectionData<Call>('calls/', [
            where('isAnswered', '==', true),
            where('sipgateUserIds', 'array-contains', sipgateUserId),
            orderBy('startAtUnix', 'desc'),
            limit(1),
        ]);
    }
    getClientCalls(clientId: string) {
        return this.firestoreService.streamCollectionData<Call>('calls/', [
            where('clientId', '==', clientId),
            orderBy('startAtUnix', 'desc'),
            limit(100),
        ]);
    }
    getLeadCalls(leadId: string) {
        return this.firestoreService.streamCollectionData<Call>('calls/', [
            where('leadId', '==', leadId),
            orderBy('startAtUnix', 'desc'),
            limit(100),
        ]);
    }
    getClientNotizen(clientId: string) {
        return this.firestoreService.streamCollectionData<Notiz>('notizen/', [
            where('clientId', '==', clientId),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getLeadNotizen(leadId: string) {
        return this.firestoreService.streamCollectionData<Notiz>('notizen/', [
            where('leadId', '==', leadId),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    async saveClient(client: Client, savedClient: Client) {
        await this.saveAdminAction('editedClient', client.name);
        const client2save = JSON.parse(JSON.stringify(client));
        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            client.clientId,
            'client',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedClient,
            client2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'clientUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );
        if (client2save.email) {
            client2save.email = client2save.email.trim();
        }
        client2save.allPhones = [];
        if (client2save.tel) {
            client2save.allPhones.push(client2save.tel);
        }
        if (client2save.mobil) {
            client2save.allPhones.push(client2save.mobil);
        }
        if (client2save.extraPhones && client2save.extraPhones.length > 0) {
            client2save.allPhones = client2save.allPhones.concat(client2save.extraPhones);
        }
        client2save.telPartials = [];
        for (const t of client2save.allPhones) {
            console.log(t);
            if (t.length > 6) {
                client2save.telPartials.push(t.substring(0, t.length - 1));
            }
            if (t.length > 7) {
                client2save.telPartials.push(t.substring(0, t.length - 2));
            }
            if (t.length > 8) {
                client2save.telPartials.push(t.substring(0, t.length - 3));
            }
        }

        delete client2save.email;
        delete client2save.leadId;
        delete client2save.leadAssignedTo;
        delete client2save.clientId;
        delete client2save.leadAtUnix;
        delete client2save.createdBy;
        delete client2save.createdAt;
        delete client2save.createdAtUnix;
        delete client2save.leadActiv;
        delete client2save.deleted;
        return this.firestoreService.updateFirestoreDocument('clients/' + client.clientId, client2save);
    }

    async createNotiz(notiz: Notiz) {
        await this.saveAdminAction('createdNotiz', notiz.id);
        notiz.id = this.firestoreService.createId();
        notiz.createdBy = this.authService.getUid();
        notiz.createdAt = new Date().toISOString();
        notiz.createdAtUnix = Date.now();
        return this.firestoreService.setFirestoreDocument('notizen/' + notiz.id, JSON.parse(JSON.stringify(notiz)));
    }

    async updateNotiz(notiz: Notiz, savedNotiz: Notiz) {
        await this.saveAdminAction('updatedNotiz', notiz.id);
        notiz.updatedAt = new Date().toISOString();
        notiz.updatedAtUnix = new Date().getTime();
        const notiz2save = JSON.parse(JSON.stringify(notiz));
        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            notiz.clientId,
            'notiz',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedNotiz,
            notiz2save,
        );

        await this.firestoreService.addToFirestoreCollection('notizUpdates/', JSON.parse(JSON.stringify(loggedUpdate)));
        return this.firestoreService.updateFirestoreDocument('notizen/' + notiz.id, notiz2save);
    }

    async setCallArchiv(xcid: string) {
        await this.saveAdminAction('setCallArchiv', xcid);
        return this.firestoreService.updateFirestoreDocument('calls/' + xcid, { archiv: true });
    }

    getOpenLeads(leadType: string, maId: string) {
        let queryConstraints = [where('leadActiv', '==', true)];
        if (leadType) {
            queryConstraints.push(where('leadType', '==', leadType));
        }
        if (maId) {
            queryConstraints.push(where('assignedTo', '==', maId));
        }
        return this.firestoreService.streamCollectionData<Lead>('leads/', queryConstraints);
    }

    async createLead(lead: Lead) {
        await this.saveAdminAction('createdLead', lead.name);
        lead.leadId = this.firestoreService.createId();
        lead.createdBy = this.authService.getUid();
        lead.createdAt = new Date().toISOString();
        lead.createdAtUnix = Date.now();
        lead.leadActiv = true;
        if (lead.email) {
            lead.email = lead.email.trim();
        }
        if (lead.tel) {
            lead.allPhones.push(lead.tel);
        }
        if (lead.mobil) {
            lead.allPhones.push(lead.mobil);
        }
        if (lead.extraPhones && lead.extraPhones.length > 0) {
            lead.allPhones = lead.allPhones.concat(lead.extraPhones);
        }
        return this.firestoreService.setFirestoreDocument('leads/' + lead.leadId, JSON.parse(JSON.stringify(lead)));
    }
    async createKnowledge(knowledge: Knowledge, knowledgeBase: string) {
        let path = 'knowledge/';
        if (knowledgeBase === 'client') {
            path = 'clientKnowledge/';
        }
        await this.saveAdminAction('createdKnowledge', knowledge.id);
        knowledge.id = this.firestoreService.createId();
        knowledge.createdBy = this.authService.getUid();
        knowledge.createdAt = new Date().toISOString();
        knowledge.createdAtUnix = Date.now();

        return this.firestoreService.setFirestoreDocument(path + knowledge.id, JSON.parse(JSON.stringify(knowledge)));
    }
    async createVideo(video: Video) {
        video.id = this.firestoreService.createId();
        await this.saveAdminAction('createdVideo', video.id);
        video.createdBy = this.authService.getUid();
        video.createdAt = new Date().toISOString();
        video.createdAtUnix = Date.now();

        return this.firestoreService.setFirestoreDocument('videos/' + video.id, JSON.parse(JSON.stringify(video)));
    }

    async saveNewsfeed(newsfeed: NewsFeedEntry) {
        await this.saveAdminAction('savedNewsfeed', newsfeed.topic);
        if (!newsfeed.id) {
            newsfeed.id = this.createId();
            newsfeed.createdAt = new Date().toISOString();
            newsfeed.createdAtUnix = Date.now();
            newsfeed.createdBy = this.authService.getUid();
        }
        newsfeed.visibleFromUnix = new Date(newsfeed.visibleFromIso).getTime();
        const newsfeed2save = JSON.parse(JSON.stringify(newsfeed));
        return this.firestoreService.setFirestoreDocument('news/' + newsfeed.id, newsfeed2save);
    }

    async saveChecklist(checklist: AccountCheckList) {
        await this.saveAdminAction('savedChecklist', checklist.name);
        if (!checklist.id) {
            checklist.id = this.createId();
        }
        const checklist2save = JSON.parse(JSON.stringify(checklist));
        return this.firestoreService.setFirestoreDocument('checklists/' + checklist.id, checklist2save);
    }

    async saveTopic(topic: Topic) {
        await this.saveAdminAction('savedTopic', topic.name);
        if (!topic.id) {
            topic.id = this.createId();
        }

        if (topic.id === topic.subTopicOf) {
            topic.subTopicOf = '';
        }
        const topic2save = JSON.parse(JSON.stringify(topic));
        return this.firestoreService.setFirestoreDocument('knowledgeTopics/' + topic.id, topic2save);
    }

    async saveLead(lead: Lead, savedLead: Lead) {
        await this.saveAdminAction('savedLead', lead.name);

        const lead2save = JSON.parse(JSON.stringify(lead));

        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            lead.leadId,
            'client',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedLead,
            lead2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'clientUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );
        lead2save.allPhones = [];

        if (lead.leadType === 'misc') {
            lead.leadClosed = true;
        }

        if (lead2save.email) {
            lead2save.email = lead2save.email.trim();
        }
        if (lead2save.tel) {
            lead2save.allPhones.push(lead2save.tel);
        }
        if (lead2save.mobil) {
            lead2save.allPhones.push(lead2save.mobil);
        }
        if (lead2save.extraPhones && lead2save.extraPhones.length > 0) {
            lead2save.allPhones = lead2save.allPhones.concat(lead2save.extraPhones);
        }

        lead2save.telPartials = [];
        for (const t of lead2save.allPhones) {
            console.log(t);
            if (t.length > 6) {
                lead2save.telPartials.push(t.substring(0, t.length - 1));
            }
            if (t.length > 7) {
                lead2save.telPartials.push(t.substring(0, t.length - 2));
            }
            if (t.length > 8) {
                lead2save.telPartials.push(t.substring(0, t.length - 3));
            }
        }

        delete lead2save.leadId;
        delete lead2save.clientId;
        delete lead2save.leadAtUnix;
        delete lead2save.createdBy;
        delete lead2save.createdAt;
        delete lead2save.createdAtUnix;
        // delete lead2save.leadActiv;
        delete lead2save.deleted;
        return this.firestoreService.updateFirestoreDocument('leads/' + lead.leadId, lead2save);
    }

    async saveVideo(video: Video, savedVideo: Video) {
        await this.saveAdminAction('savedVideo', video.id);

        const video2save = JSON.parse(JSON.stringify(video));

        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            video.id,
            'videos',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedVideo,
            video2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'clientUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );

        delete video2save.createdBy;
        delete video2save.createdAt;
        delete video2save.createdAtUnix;
        // delete lead2save.leadActiv;
        return this.firestoreService.updateFirestoreDocument('videos/' + video2save.id, video2save);
    }

    async saveKnowledge(knowledge: Knowledge, savedKnowledge: Knowledge, knowledgeBase: string) {
        await this.saveAdminAction('savedKnowledge', knowledge.id);

        let path = 'knowledge/';
        if (knowledgeBase === 'client') {
            path = 'clientKnowledge/';
        }

        const knowledge2save = JSON.parse(JSON.stringify(knowledge));

        const now = Date.now();
        const loggedUpdate = new LoggedUpdate(
            knowledge.id,
            path,
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedKnowledge,
            knowledge2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'clientUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );

        delete knowledge2save.createdBy;
        delete knowledge2save.createdAt;
        delete knowledge2save.createdAtUnix;
        // delete lead2save.leadActiv;
        return this.firestoreService.updateFirestoreDocument(path + knowledge2save.id, knowledge2save);
    }

    async createTrelloCard(ticket: Ticket, commentsText, attachments: string[]) {
        await this.saveAdminAction('createTrelloCard', ticket.ticketId);
        const card = new TrelloCard();
        card.ticketId = ticket.ticketId;
        card.name = ticket.topic;
        card.desc = ticket.clientInfo + '\n' + commentsText;
        card.trelloListName = 'Support';
        card.lastUpdateFromBackend = true;
        card.id = this.firestoreService.createId();
        if (attachments && attachments.length > 0) {
            attachments.forEach((a) => {
                let mime = '';
                let urlC = a.toUpperCase();
                let name = 'Attachment' + attachments.indexOf(a);
                if (urlC.split('.PNG').length > 1) {
                    mime = 'image/png';
                    name = name + '.PNG';
                }
                if (urlC.split('.JPG').length > 1) {
                    mime = 'image/jpeg';
                    name = name + '.JPG';
                }
                if (urlC.split('.JPEG').length > 1) {
                    mime = 'image/jpeg';
                    name = name + '.JPG';
                }
                if (urlC.split('.PDF').length > 1) {
                    mime = 'application/pdf';
                    name = name + '.PDF';
                }
                if (mime) {
                    card.attachments.push({
                        name: name,
                        mimeType: mime,
                        url: a,
                    });
                }
            });
        }
        const card2save = JSON.parse(JSON.stringify(card));
        await this.firestoreService.setFirestoreDocument<TrelloCard>('trelloCards/' + card2save.id, card2save);
        return this.firestoreService.updateFirestoreDocument('tickets/' + ticket.ticketId, { trelloCardId: card.id });
    }

    async createJiraTicket(ticket: Ticket, commentsText, attachments: string[]) {
        await this.saveAdminAction('createJiraTicket', ticket.ticketId);

        const ticketId = ticket.ticketId;
        const summary = ticket.topic;
        const description = ticket.clientInfo + '\n' + commentsText;
        const jiraAttachments: any = [];
        if (attachments && attachments.length > 0) {
            attachments.forEach((a) => {
                let mime = '';
                let urlC = a.toUpperCase();
                let name = 'Attachment' + attachments.indexOf(a);
                if (urlC.split('.PNG').length > 1) {
                    mime = 'image/png';
                    name = name + '.PNG';
                }
                if (urlC.split('.JPG').length > 1) {
                    mime = 'image/jpeg';
                    name = name + '.JPG';
                }
                if (urlC.split('.JPEG').length > 1) {
                    mime = 'image/jpeg';
                    name = name + '.JPG';
                }
                if (urlC.split('.PDF').length > 1) {
                    mime = 'application/pdf';
                    name = name + '.PDF';
                }
                if (mime) {
                    jiraAttachments.push({
                        name: name,
                        mimeType: mime,
                        url: a,
                    });
                }
            });
        }

        this.checkLocalFnc();
        return this.fns('requestCreateJiraCard', {
            ticketId,
            ticketNo: ticket.ticketNo,
            summary,
            description,
            attachments: jiraAttachments,
        });
    }

    async saveTicket(ticket: Ticket, savedTicket: Ticket) {
        await this.saveAdminAction('savedTicket', ticket.ticketId);
        const now = Date.now();
        ticket.updatedBy = this.authService.getUid();
        ticket.updatedAt = new Date().toISOString();
        ticket.updatedAtUnix = now;
        if (!savedTicket.clientId && !savedTicket.leadId) {
            if (ticket.leadId) {
                ticket.type = 'lead';
            }
        }
        const ticket2save = JSON.parse(JSON.stringify(ticket));

        const loggedUpdate = new LoggedUpdate(
            ticket.ticketId,
            'ticket',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedTicket,
            ticket2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'ticketUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );
        return this.firestoreService.updateFirestoreDocument('tickets/' + ticket2save.ticketId, ticket2save);
    }

    async saveFeatureRequest(featureRequest: FeatureRequest, savedFeatureRequest: FeatureRequest) {
        await this.saveAdminAction('savedFeatureRequest', featureRequest.id);
        const now = Date.now();
        featureRequest.updatedBy = this.authService.getUid();
        featureRequest.updatedAt = new Date().toISOString();
        featureRequest.updatedAtUnix = now;

        const featureRequest2save = JSON.parse(JSON.stringify(featureRequest));

        const loggedUpdate = new LoggedUpdate(
            featureRequest.id,
            'featureRequest',
            this.authService.getUid(),
            new Date().toISOString(),
            now,
            savedFeatureRequest,
            featureRequest2save,
        );
        await this.firestoreService.addToFirestoreCollection(
            'featureRequestUpdates/',
            JSON.parse(JSON.stringify(loggedUpdate)),
        );
        return this.firestoreService.updateFirestoreDocument(
            'featureRequests/' + featureRequest2save.id,
            featureRequest2save,
        );
    }

    getNewsFeed() {
        return this.firestoreService.streamCollectionData<NewsFeedEntry>('news/', [orderBy('visibleFromUnix', 'desc')]);
    }

    getChecklists() {
        return this.firestoreService.streamCollectionData<AccountCheckList>('checklists/', [
            where('deleted', '==', false),
        ]);
    }

    getChecklistsPromise() {
        return this.firestoreService.fetchCollectionData<AccountCheckList>('checklists/', [
            where('deleted', '==', false),
        ]);
    }

    getChecklistToDosPromise(checklistId: string) {
        return this.firestoreService.fetchCollectionData<AccountToDo>('checklistEntries/', [
            where('listId', '==', checklistId),
        ]);
    }
    getChecklistToDos(checklistId: string) {
        return this.firestoreService.streamCollectionData<AccountToDo>('checklistEntries/', [
            where('listId', '==', checklistId),
        ]);
    }

    async deleteToDo(toDo: AccountToDo) {
        await this.saveAdminAction('deleteToDo', toDo.title);
        // Updated: use FirestoreService for delete
        return this.firestoreService.deleteFirestoreDocument('checklistEntries/' + toDo.id);
    }
    async saveChecklistToDo(toDo: AccountToDo) {
        await this.saveAdminAction('savedToDo', toDo.title);
        if (!toDo.id) {
            toDo.id = this.createId();
        }
        const checklist2save = JSON.parse(JSON.stringify(toDo));
        return this.firestoreService.setFirestoreDocument('checklistEntries/' + toDo.id, checklist2save);
    }

    getBookmarkedTickets() {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('bookmarked', '==', true),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getClosedTickets() {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('done', '==', true),
            orderBy('doneAtUnix', 'desc'),
            limit(1000),
        ]);
    }

    getFeatureRequestsWithStatus(status: string) {
        return this.firestoreService.streamCollectionData<any>('featureRequests/', [
            where('status', '==', status),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getDeletedFeatureRequests() {
        return this.firestoreService.streamCollectionData<any>('featureRequests/', [
            where('deleted', '==', true),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    getOpenTickets() {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('done', '==', false),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getMyOpenTickets() {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('done', '==', false),
            where('assignedTo', '==', this.authService.getUid()),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getClientTickets(clientId: string) {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('clientId', '==', clientId),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }
    getLeadTickets(leadId: string) {
        return this.firestoreService.streamCollectionData<any>('tickets/', [
            where('leadId', '==', leadId),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    findClientByEmail(email: string) {
        return this.firestoreService.fetchCollectionData<Client>('clients', [where('email', '==', email)]);
    }
    getClientPromise(clientId: string) {
        return this.firestoreService.fetchDocumentData<Client>('clients/' + clientId);
    }

    getUserClaims() {
        return this.authService.getUserClaims();
    }

    // Offers methods
    getOffers() {
        return this.firestoreService.streamCollectionData<Offer>('offers/', [
            where('deleted', '==', false),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    getOffer(offerId: string) {
        return this.firestoreService.streamDocumentData<Offer>('offers/' + offerId);
    }

    async saveOffer(offer: Offer, savedOffer: Offer | null) {
        await this.saveAdminAction('saveOffer', offer.id);

        const offer2save = JSON.parse(JSON.stringify(Object.assign(new Offer(), offer)));

        if (!offer.id) {
            // New offer
            offer2save.id = this.firestoreService.createId();
            offer2save.createdBy = this.authService.getUid();
            offer2save.createdAt = new Date().toISOString();
            offer2save.createdAtUnix = Date.now();
            return this.firestoreService.setFirestoreDocument('offers/' + offer2save.id, offer2save);
        } else {
            // Update existing offer
            const now = Date.now();
            const loggedUpdate = new LoggedUpdate(
                offer.id,
                'offers/',
                this.authService.getUid(),
                new Date().toISOString(),
                now,
                savedOffer,
                offer2save,
            );
            await this.firestoreService.addToFirestoreCollection(
                'clientUpdates/',
                JSON.parse(JSON.stringify(loggedUpdate)),
            );

            offer2save.updatedBy = this.authService.getUid();
            offer2save.updatedAt = new Date().toISOString();
            offer2save.updatedAtUnix = Date.now();

            delete offer2save.createdBy;
            delete offer2save.createdAt;
            delete offer2save.createdAtUnix;

            return this.firestoreService.updateFirestoreDocument('offers/' + offer2save.id, offer2save);
        }
    }

    async deleteOffer(offerId: string) {
        await this.saveAdminAction('deleteOffer', offerId);
        return this.firestoreService.updateFirestoreDocument('offers/' + offerId, {
            deleted: true,
            updatedBy: this.authService.getUid(),
            updatedAt: new Date().toISOString(),
            updatedAtUnix: Date.now(),
        });
    }

    // Orders methods
    getOrders() {
        return this.firestoreService.streamCollectionData<Order>('orders/', [
            where('archived', '==', false),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    getArchivedOrders() {
        return this.firestoreService.streamCollectionData<Order>('orders/', [
            where('archived', '==', true),
            orderBy('createdAtUnix', 'desc'),
        ]);
    }

    getOrder(orderId: string) {
        return this.firestoreService.streamDocumentData<Order>('orders/' + orderId);
    }

    async archiveOrder(orderId: string) {
        await this.saveAdminAction('archiveOrder', orderId);
        return this.firestoreService.updateFirestoreDocument('orders/' + orderId, {
            archived: true,
        });
    }

    async unarchiveOrder(orderId: string) {
        await this.saveAdminAction('unarchiveOrder', orderId);
        return this.firestoreService.updateFirestoreDocument('orders/' + orderId, {
            archived: false,
        });
    }
}
